import { render } from "./SimilarityProtocolForm.vue?vue&type=template&id=9f5d2582&ts=true"
import script from "./SimilarityProtocolForm.vue?vue&type=script&lang=ts"
export * from "./SimilarityProtocolForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__